import api from './client';

/**
 * Authentication API calls
 */
export const authAPI = {
  /**
   * Register new user
   */
  register: async (userData: any) => {
    const response = await api.post('/api/auth/register/', userData);
    return response.data;
  },

  /**
   * Login user
   */
  login: async (username: string, password: string) => {
    const response = await api.post('/api/auth/login/', {
      username,
      password,
    });
    return response.data;
  },

  /**
   * Logout user
   */
  logout: async () => {
    const response = await api.post('/api/auth/logout/');
    return response.data;
  },

  /**
   * Get current user info
   */
  me: async () => {
    const response = await api.get('/api/auth/me/');
    return response.data;
  },

  /**
   * Change password
   */
  changePassword: async (oldPassword: string, newPassword: string, newPasswordConfirm: string) => {
    const response = await api.put('/api/auth/change-password/', {
      old_password: oldPassword,
      new_password: newPassword,
      new_password_confirm: newPasswordConfirm,
    });
    return response.data;
  },
};
